import React from 'react';
import {Container, Grid, Icon, Paper, Typography} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import {getTripFormattedDate, isDealerSite} from "../../../utils/utils";
import {styled} from "@mui/material/styles";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PrimaryButton from "../../Common/PrimaryButton";
// import {Link} from "react-router-dom";

const PreTripCard = ({booking, booking: {trip, berths}, myBooking = false, viewDetails = false}) => {
    const locationIcon = trip?.tripClassName !== 'San Ignacio Lagoon' ?
        <Icon style={{color: lightBlue[500]}} className={'tripInfoIcon'}>directions_boat</Icon> :
        <Icon style={{color: lightBlue[500], width: 35}} className={'tripInfoIcon fa fa-campground'}/>;

    const PREFIX = 'PreTripCard';

    const classes = {
        root: `${PREFIX}-root`,
        container: `${PREFIX}-container`,
        tripImage: `${PREFIX}-trip-image`,
        tripTitle: `${PREFIX}-tripTitle`,
        tripDetailsContainer: `${PREFIX}-tripDetailsContainer`,
        tripDetails: `${PREFIX}-tripDetails`,
        footerInfo: `${PREFIX}-footerInfo`,
        rightSideContainer: `${PREFIX}-rightSideContainer`,
        packageLink: `${PREFIX}-packageLink`,
        packageLinkContainer: `${PREFIX}-packageLinkContainer`,
    }

    const PreTripPaper = styled(Paper)(({theme}) => ({
        [`&.${classes.root}`]: {
            marginTop: myBooking ? 0 : '20px',
            width: '100%',
        },
        [`& .${classes.status}`]: {
            color: 'white',
            padding: '5px',
            textTransform: 'uppercase',
            fontWeight: '600',
            fontSize: '1.4rem',
            letterSpacing: '1.2px',
        },
        [`& .${classes.container}`]: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        [`& .${classes.tripImage}`]: {
            objectFit: 'cover',
            height: '100%',
        },
        [`& .${classes.tripTitle}`]: {
            fontSize: '2rem',
            fontWeight: '600',
        },
        [`& .${classes.tripDetailsContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
        },
        [`& .${classes.tripDetails}`]: {
            fontSize: '1.2rem',
            marginLeft: '5px'
        },
        [`& .${classes.footerInfo}`]: {
            fontWeight: '600'
        },
        [`& .${classes.rightSideContainer}`]: {
            position: 'relative',
        },
        [`& .${classes.packageLinkContainer}`]: {
            position: 'absolute',
            bottom: 0,
            backgroundColor: theme.palette.warning.main,
            textAlign: 'center',
        },
        [`& .${classes.packageLink}`]: {
            margin: '0.5rem',
            fontSize: '1.6rem',
            fontWeight: '500',
            color: theme.palette.common.white,
            letterSpacing: '1.2px',
        },
    }));

    const elevation = myBooking ? 0 : 3;

    const viewBookingDetails = () => {
        const url = `${window['appBasename']}/booking/email-confirmation/${booking.id}`;
        window.open(url, '_blank');
    };
    const PrintBookingDetails = () => {
        const url = `${window['appBasename']}/booking/email-confirmation-print/${booking.id}`;
        window.open(url, '_blank');
    };

    return (
        <PreTripPaper className={classes.root} elevation={elevation}>
            <Grid container>
                <Grid item sm={12} md={3} container justifyContent="center">
                    <img className={classes.tripImage} src={trip.tripImageCard} alt={trip.shortcomment}/>
                </Grid>
                <Grid item sm={12} md={9} className={classes.rightSideContainer}>
                    <Container style={{marginBottom: '50px'}}>
                        <div style={{margin: '20px 10px'}}>
                            <Typography variant="h3" className={classes.tripTitle}>
                                {trip.tripClassName} - {trip.shortcomment}
                            </Typography>
                            <Grid container spacing={1} style={{paddingTop: '10px'}}>
                                <Grid item className={classes.tripDetailsContainer} xs={12}>
                                    <Icon style={{color: lightBlue[500]}}
                                          className={'tripInfoIcon far fa-calendar-alt'}/>
                                    <span className={classes.tripDetails}>
                                        {getTripFormattedDate(trip.boarddate, trip.returndate)}
                                    </span>
                                </Grid>
                                <Grid item className={classes.tripDetailsContainer} xs={12}>
                                    <Icon style={{color: lightBlue[500]}} className={'tripInfoIcon'}>nights_stay</Icon>
                                    <span className={classes.tripDetails}>
                                        {trip.length} nights {trip.length + 1} days
                                    </span>
                                </Grid>
                                <Grid item className={classes.tripDetailsContainer} xs={12}>
                                    {locationIcon}
                                    <span className={classes.tripDetails}>{trip.location.location}</span>
                                </Grid>
                            </Grid>
                            <Grid container style={{margin: '10px 0'}}>
                                <Grid item xs={12} md={6}>
                                    <Typography className={classes.footerInfo} variant="h5">
                                        Booking Confirmation #: {booking.Confirmation}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    {myBooking && (<Typography className={classes.footerInfo}
                                                  variant="h5">Accommodation:
                                        {berths.map(berth => (<span key={berth.index}>
                                            &nbsp;{berth.count} {berth.count > 1 ? 'berths' : 'berth'} in <span
                                            dangerouslySetInnerHTML={{__html: berth.title}}/>.
                                        </span>))}
                                    </Typography>)}
                                </Grid>
                                {myBooking && (<Grid item xs={12} md={6}>
                                    <PrimaryButton style={{width: 'auto', marginTop: '10px', marginLeft: '0'}}
                                                   onClick={viewBookingDetails}>
                                        View Details
                                    </PrimaryButton>
                                </Grid>)}
                                {myBooking && isDealerSite() && (<Grid item xs={12} md={6}>
                                    <PrimaryButton style={{width: 'auto', marginTop: '10px', marginLeft: '0'}}
                                                   onClick={PrintBookingDetails}>
                                        Print Details
                                    </PrimaryButton>
                                </Grid>)}
                            </Grid>
                        </div>
                    </Container>
                    <Container className={classes.packageLinkContainer}>
                        <a href="https://nautilusliveaboards.com/pre-trip-info" target="_blank" style={{textDecoration: 'none'}}>
                            <Typography variant="h3" className={classes.packageLink}>
                                Read The Pre-Trip Information Package <OpenInNewIcon/>
                            </Typography>
                        </a>
                    </Container>
                </Grid>
            </Grid>
        </PreTripPaper>
    );
};

export default PreTripCard;